import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import moment from 'moment';
import { PayPalButton } from 'react-paypal-button-v2';

import config from '../../../../config';
import { getPriceCent, getPriceFromCent } from '../../../../util/price';
import { notifyError } from '../../../../components/Error/ErrorBoundary';

import { validPaymentRequest } from '../../OrderActions';
import { editSubscriptionRequest, getSubscriptionPaypalPlanRequest } from '../../../Subscription/SubscriptionActions';
import { getLoggedUser } from '../../../User/UserActions';
import { getLanguagePath, getCountryFromLanguage } from '../../../Intl/IntlActions';

class PaypalPayment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            order: props.order || null,
            subscription: props.subscription || null,
            payment: props.payment || null,
            isLoading: false,
            isMounted: true,
            hasError: false,
        };

        this.buttonId = 'paypal-payment-submit-button';
    }

    // componentDidMount() {
    //     console.log('Paypal button mounted');
    //     const scripts = document.getElementsByTagName('script');
    //     if(scripts && scripts.length) {
    //         let paypalScript = null;
    //         scripts.forEach(script => {
    //             if(script.src.includes('paypal.com')) {
    //                 paypalScript = script;
    //             }
    //         });
    //         if(paypalScript) {
    //             console.log('Paypal script found and will be removed', paypalScript);
    //             paypalScript.remove();
    //             // PayPalButton.addPaypalSdk();
    //             // window.paypal = undefined;
    //             setTimeout(() => {
    //                 this.setState({
    //                     isMounted: true,
    //                 });
    //             }, 2000);
    //         } else {
    //             console.log('Paypal script not found!');
    //             this.setState({
    //                 isMounted: true,
    //             });
    //         }
    //     }
    // }

    // componentDidUpdate(prevProps, prevState) {
    //     console.log('Paypal Button Update', prevProps, this.props, prevState, this.state);
    //     if(
    //         (!prevState.subscription && this.state.subscription)
    //         || (!prevProps.isSubscription && this.props.isSubscription)
    //     ) {
    //         console.log('Update catch');
    //         this.setState({
    //             isSwitching: true,
    //         }, () => {
    //             setTimeout(() => {
    //                 this.setState({
    //                     isSwitching: false,
    //                 });
    //             }, 2000);
    //         });
    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.subscription && nextProps.subscription !== prevState.subscription) {
            return {
                subscription: nextProps.subscription,
            };
        }
        return null;
    }

    getBackUrl = (isFullUrl = false) => {
        const { intl } = this.props;
        const { order } = this.state;
        if(order) {
            let { user } = order || {};
            if(!user || !user._id) {
                user = this.props.user;
            }
            const isAdmin = this.props.user.role === 'admin' && this.props.user._id !== user._id;
            const path = getLanguagePath(`/${isAdmin ? `console/order/${order._id}` : `cart/confirmation/${order._id}`}`, intl.locale);
            return isFullUrl ? `${config.url.substring(0, config.url.length - 1)}${path}` : path;
        }
        return isFullUrl ? config.url : '';
    }

    isSubscription = () => {
        return !!(this.props.isSubscription || this.state.subscription || this.props.subscription);
    }

    getTransactionDetails = (order, payment) => {
        const { currency } = this.props;
        // const { order, payment } = this.state;
        if(order && payment) {
            let { user } = order || {};
            if(!user || !user._id) {
                user = this.props.user;
            }

            const shipping = order.shippings && order.shippings[0] ? order.shippings[0] : {};
            const { address } = shipping;

            const backUrl = this.getBackUrl(true);

            return {
                purchase_units: [{
                    'reference_id': `${order._id}/${payment.id}/${moment.utc().format('mmss')}`,
                    'custom_id': `${order.code}`,
                    'invoice_id': `${order.code}`,
                    'description': order.items.map(item => `${item.quantity + item.freeCount}x${item.sku}`).join('/'),
                    'amount': {
                        'currency_code': currency.toUpperCase(),
                        'details': {
                            'subtotal': order.totals.subtotalHT,
                            'shipping': order.totals.shippingFee,
                            'tax': order.totals.tax,
                        },
                        'value': order.totals.totalTTC,
                    },
                    // Error: on unit_amount
                    // 'items': order.items.map(item => ({
                    //     name: item.name,
                    //     sku: item.sku,
                    //     unit_amount: {
                    //         value: getPriceFromCent(getPriceCent(item.unitPriceHt || item.priceHT)),
                    //         currency_code: currency.toUpperCase(),
                    //     },
                    //     quantity: item.quantity,
                    // })),
                    'shipping_address': {
                        'line1': address.street1 || '',
                        'line2': address.street2 || '',
                        'city': address.city || '',
                        'country_code': address.countryCode || '',
                        'postal_code': address.postalCode || '',
                        'state': '',
                        'phone': address.phone || user.phone || '',
                    },
                    'shipping_method': shipping.carrier,
                }],
                application_context: {
                    shippingPreference: 'SET_PROVIDED_ADDRESS',
                },
                'redirect_urls': {
                    'return_url': backUrl,
                    'cancel_url': backUrl,
                },
            };
        }
        return {};
    }

    getSubscriptionDetails = (order, plan) => {
        // let { user } = order || {};
        // if(!user || !user._id) {
        //     user = this.props.user;
        // }

        // const backUrl = this.getBackUrl(true);

        if(!plan) {
            return {};
        }

        return {
            plan_id: plan.id,
            // name: plan.name,
            // start_time: moment.utc().format(),
            // subscriber: {
            //     name: {
            //         given_name: user.firstName,
            //         surname: user.lastName,
            //     },
            //     email_address: user.email,
            // },
            // application_context: {
            //     brand_name: config.application.name,
            //     locale: `${this.props.intl.locale}-${getCountryFromLanguage(this.props.intl.locale)}`,
            //     shipping_preference: 'SET_PROVIDED_ADDRESS',
            //     user_action: 'SUBSCRIBE_NOW',
            //     payment_method: {
            //         payer_selected: 'PAYPAL',
            //         payee_preferred: 'IMMEDIATE_PAYMENT_REQUIRED',
            //     },
            //     return_url: backUrl,
            //     cancel_url: backUrl,
            // },
        };
    }

    getCallBacks = () => {
        // const { order, subscription, payment } = this.state;
        const onError = err => {
            notifyError(err);
            console.error(err);
            this.setState({
                isLoading: false,
                hasError: true,
            });
        };
        const callbacks = {
            onError,
            catchError: onError,
            onCancel: data => {
                this.setState({
                    isLoading: false,
                });
            },
        };

        // Fix shipping address change bug => https://github.com/paypal/paypal-checkout-components/issues/1521
        callbacks.onShippingChange = (data, actions) => {
            // if not needed do nothing..
            return actions.resolve();
        };

        if(this.isSubscription()) {
            callbacks.createSubscription = (data, actions) => {
                this.setState({
                    isLoading: true,
                });
                return (
                    this.state.order && this.state.payment
                    ? Promise.resolve(this.state)
                    : this.props.validOrder()
                ).then(({ order, subscription, payment }) => {
                    console.log('validOrder results', order, subscription, payment);
                    this.setState({
                        order,
                        subscription,
                        payment,
                    });
                    return this.props.dispatch(getSubscriptionPaypalPlanRequest(subscription._id)).then(plan => {
                        plan ? console.log('actions.subscription.create', plan.id, actions.subscription) : console.error('Subscription error: No Plan', subscription, order, plan);
                        const subscriptionDetails = this.getSubscriptionDetails(order, plan);
                        console.log(subscriptionDetails);
                        return actions.subscription.create(subscriptionDetails);
                    });
                });
            };

            callbacks.onApprove = (data, actions) => {
                console.log('OnApprove', data, actions);
                // Capture the funds from the transaction
                const { order, subscription, payment } = this.state;
                return actions.subscription.get().then(details => {
                    console.log('subscription paypal details', details);
                    this.setState({
                        isLoading: true,
                    });
                    // OPTIONAL: Call your server to save the transaction
                    this.props.dispatch(validPaymentRequest(order._id, payment.id, details)).then(order => {
                        this.props.dispatch(editSubscriptionRequest({
                            ...subscription,
                            reference: data.subscriptionID,
                            status: order && order.status === 'onpreparation' ? 'active' : 'inactive',
                        })).then(subscription => {
                            this.setState({
                                isLoading: false,
                                hasError: false,
                            });
                            this.props.redirect && this.props.history.push(this.getBackUrl());
                        });
                    });
                });
            };
        } else {
            callbacks.createOrder = (data, actions) => {
                this.setState({
                    isLoading: true,
                });
                return (
                    this.state.order && this.state.payment
                    ? Promise.resolve(this.state)
                    : this.props.validOrder()
                ).then(({ order, subscription, payment }) => {
                    console.log('validOrder results', order, subscription, payment);
                    this.setState({
                        order,
                        subscription,
                        payment,
                    });
                    const paypalTransaction = this.getTransactionDetails(order, payment);
                    console.log(paypalTransaction);
                    return actions.order.create(paypalTransaction);
                });
            };

            callbacks.onSuccess = (details, data) => {
                console.log('details', details);
                console.log('data', data);
                // alert(`Transaction completed by ${details.payer.name.given_name}`);

                this.setState({
                    isLoading: true,
                });
                // OPTIONAL: Call your server to save the transaction
                this.props.dispatch(validPaymentRequest(this.state.order._id, this.state.payment.id, { ...details, ...data })).then(result => {
                    this.setState({
                        isLoading: false,
                        hasError: false,
                    });
                    this.props.redirect && this.props.history.push(this.getBackUrl());
                });
            };
        }

        console.log(callbacks);

        return callbacks;
    }

    render() {
        const { currency } = this.props;
        if(currency && !this.state.hasError) {
            console.log('Is subscription?', this.isSubscription());
            if(!this.state.isMounted) {
                return (
                    <div className="text-warning text-center">We are updating your data...</div>
                );
            }
            return (
                <div>
                    <small className="d-block text-center"><FontAwesome name="info-circle" /> <FormattedMessage id="orderPaymentPaypalHelp" defaultMessage="Click on this button below to pay with Paypal" /></small>
                    <PayPalButton
                        vault={this.isSubscription()}
                        options={{
                            clientId: config.paypal.clientId,
                            currency: currency.toUpperCase(),
                            intent: this.isSubscription() ? 'subscription' : 'capture',
                            disableFunding: 'card,sofort',
                            vault: this.isSubscription(),
                            debug: false && process.env.NODE_ENV === 'development',
                        }}
                        style={{
                            label: 'pay',
                            shape: 'pill',
                            tagline: false,
                        }}
                        {...this.getCallBacks()}
                    />
                    {process.env.NODE_ENV === 'development' && <span className="text-danger">{this.isSubscription() ? 'Subscription' : 'Normal'} mode</span>}
                    {this.state.isLoading && (
                        <div className="h4 mt-3 text-center text-success">
                            <FontAwesome name="spinner" spin /> <FormattedMessage id="orderPaymentProcessing" defaultMessage="We are collecting your payment..." />
                        </div>
                    )}
                </div>
            );
        }
        return (
            <div className="text-center text-danger">
                <FontAwesome name="exclamation-circle" /> <FormattedMessage id="orderPaymentUnavailableAlert" defaultMessage="Payment method not available... Please contact us to pay your order." />
                <Button color="danger" outline size="sm" onClick={() => window.location.reload}>Retry</Button>
            </div>
        );
    }
}

function mapStateToProps(store, props) {
    return {
        user: getLoggedUser(store),
        currency: store.currency.currency,
    };
}

PaypalPayment.defaultProps = {
    user: null,
    order: null,
    payment: null,
    subscription: null,
    validOrder: null,
    redirect: false,
    isSubscription: false,
};

PaypalPayment.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    history: PropTypes.object.isRequired,
    order: PropTypes.object,
    payment: PropTypes.object,
    subscription: PropTypes.object,
    validOrder: PropTypes.func,
    redirect: PropTypes.bool,
    isSubscription: PropTypes.bool,
    user: PropTypes.object,
    currency: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(injectIntl(withRouter(PaypalPayment)));
